export default {
  //复制文本(cptxt=需要复制的文本)
  copyFont(cptxt) {
    return new Promise((resolve, reject) => {
      var oInput = document.createElement('input');
      oInput.value = cptxt;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.className = 'oInput';
      oInput.style.display = 'none';
      resolve();
    })
  },

  //验证是否必填项
  isRequired(sname) {
    return new Promise((resolve, reject) => {
      if (sname == '' || sname == null || !sname) {
        reject();
      } else {
        resolve(); //已填写时执行
      }
    })
  },

  //验证邮箱
  isEmail(email) {
    return new Promise((resolve, reject) => {
      var emailRegExp = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (emailRegExp.test(email)) {
        resolve(); //已填写时执行
      } else {
        reject();
      }
    })
  },

  //验证手机号
  isTel(tel) {
    return new Promise((resolve, reject) => {
      let myreg = /^(((1[0-9]{2}))+\d{8})$/;
      if (tel.length != 11 || !myreg.test(tel)) {
        reject();
      } else {
        resolve(tel); //已填写时执行
      }
    })
  },

  // 只能输入纯数字(不含小数)
  isNum(text) {
    var re = /^[0-9]*$/; //数字验证
    return new Promise((resolve, reject) => {
      if (re.test(text) && text > 0) {
        resolve();
      } else {
        reject();
      }
    })
  },

  //滚动到顶部
  pageScrrolTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
  }

}



// WEBPACK FOOTER //
// ./src/util/mpublic.js